(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mue-avis"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mue-reviews-carousel')) {
    customElements.define('mue-reviews-carousel', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.track = this.querySelector('[data-reviews-track]');
        if (!this.track) return;
        this.track.querySelectorAll('.jdgm-rev').forEach(card => {
          const title = card.querySelector('.jdgm-rev__title');
          if (/^[0-9]+$/.test(title?.textContent?.trim() || '')) title.remove();
        });
        this.cards = Array.from(this.track.querySelectorAll('.jdgm-rev'));
        this.decorateProfiles();
        this.preparePhotos();
        this.spreadReviews();
        this.previous = this.querySelector('[data-reviews-previous]');
        this.next = this.querySelector('[data-reviews-next]');
        this.position = this.querySelector('[data-reviews-position]');
        this.navigation = this.querySelector('[data-reviews-navigation]');
        const formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'fr', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
        this.querySelectorAll('.jdgm-rev__timestamp').forEach(element => {
          const date = new Date(element.getAttribute('datetime'));
          if (Number.isNaN(date.getTime())) return;
          element.textContent = formatter.format(date);
          element.classList.remove('jdgm-spinner');
        });
        if (!this.navigation) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }
      decorateProfiles() {
        const source = this.querySelector('[data-mue-review-profiles]');
        const profiles = new Map(Array.from(source?.content.querySelectorAll('[data-review-id]') || [], node => [node.dataset.reviewId, node.dataset]));
        this.cards.forEach(card => {
          const header = card.querySelector('.jdgm-rev__header');
          if (!header) return;
          const profile = profiles.get(card.dataset.reviewId);
          const values = [profile?.height, profile?.braSize].filter(value => value?.trim());
          if (values.length && !header.querySelector('.mue-avis__profile')) {
            const line = document.createElement('p');
            line.className = 'mue-avis__profile';
            line.textContent = values.join(' · ');
            header.append(line);
          }
          const authorWrapper = card.querySelector('.jdgm-rev__author-wrapper');
          if (card.dataset.verifiedBuyer === 'true' && authorWrapper && !authorWrapper.querySelector('.mue-avis__verified')) {
            const verified = document.createElement('span');
            verified.className = 'mue-avis__verified';
            verified.textContent = this.dataset.verifiedLabel || '';
            authorWrapper.append(verified);
          }
          const badge = card.querySelector('.jdgm-rev__buyer-badge-wrapper');
          if (badge) badge.hidden = true;
        });
      }
      preparePhotos() {
        this.cards.forEach(card => {
          const pictures = card.querySelector('.jdgm-rev__pics');
          if (!pictures) return;
          if (card.dataset.muePhotoIndex === '0') { pictures.hidden = true; return; }
          const links = [...pictures.querySelectorAll('.jdgm-rev__pic-link')];
          const index = Math.max(0, Number(card.dataset.muePhotoIndex || 1) - 1);
          const selected = links[index] || links[0];
          const image = selected?.querySelector('img');
          if (!selected || !image) return;
          const raw = image.dataset.src || image.getAttribute('src') || selected.href;
          try {
            const display = new URL(raw, document.baseURI);
            const original = new URL(selected.getAttribute('href') || raw, document.baseURI);
            if (!['https:', 'http:'].includes(display.protocol) || !['https:', 'http:'].includes(original.protocol)) return;
            if (display.hostname === 'review-images.judgeme.com') display.searchParams.set('width', '320');
            image.src = display.href;
            image.removeAttribute('data-src');
            image.removeAttribute('srcset');
            image.alt = this.dataset.photoLabel || '';
            image.width = 320;
            image.height = 400;
            image.loading = 'lazy';
            image.decoding = 'async';
            selected.href = original.href;
            selected.target = '_blank';
            selected.rel = 'noopener nofollow';
            selected.setAttribute('aria-label', this.dataset.photoLabel || '');
            selected.classList.remove('jdgm--loading');
            const caption = document.createElement(pictures.tagName === 'FIGURE' ? 'figcaption' : 'p');
            caption.className = 'mue-avis__photo-caption';
            caption.textContent = this.dataset.photoLabel || '';
            pictures.replaceChildren(selected, caption);
            card.append(pictures);
            card.classList.add('mue-review--photo');
          } catch {}
        });
      }
      spreadReviews() {
        if (this.cards.some(card => card.classList.contains('mue-review--photo'))) return;
        const normalize = value => value.trim().toLocaleLowerCase('fr').replace(/\s+/g, ' ');
        const pending = this.cards.map(card => ({
          card,
          title: normalize(card.querySelector('.jdgm-rev__title')?.textContent || ''),
          opening: normalize((card.querySelector('.jdgm-rev__body')?.textContent || '').split(/[.!?]/)[0])
        }));
        const ordered = [];
        while (pending.length) {
          let best = 0;
          let bestScore = Infinity;
          pending.forEach((review, index) => {
            const score = ordered.slice(-2).reverse().reduce((total, previous, distance) => {
              const repeatedTitle = review.title && review.title === previous.title ? 2 : 0;
              const repeatedOpening = review.opening && review.opening === previous.opening ? 2 : 0;
              return total + (repeatedTitle + repeatedOpening) * (distance === 0 ? 3 : 1);
            }, 0);
            if (score < bestScore) { best = index; bestScore = score; }
          });
          ordered.push(pending.splice(best, 1)[0]);
        }
        this.cards = ordered.map(review => review.card);
        this.track.append(...this.cards);
      }
      move(direction) {
        const edge = this.track.getBoundingClientRect().left;
        let current = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const value = Math.abs(card.getBoundingClientRect().left - edge);
          if (value < distance) { distance = value; current = index; }
        });
        const target = this.cards[Math.max(0, Math.min(this.cards.length - 1, current + direction))];
        if (!target) return;
        const left = this.track.scrollLeft + target.getBoundingClientRect().left - edge;
        this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        if (!this.track || !this.navigation) return;
        const limit = this.track.scrollWidth - this.track.clientWidth;
        this.navigation.hidden = limit < 3;
        this.previous.disabled = this.track.scrollLeft < 3;
        this.next.disabled = this.track.scrollLeft >= limit - 3;
        const bounds = this.track.getBoundingClientRect();
        const visible = this.cards.map((card, index) => ({ index, rect: card.getBoundingClientRect() })).filter(item => item.rect.right > bounds.left + 3 && item.rect.left < bounds.right - 3);
        if (visible.length) {
          const first = visible[0].index + 1;
          const last = visible[visible.length - 1].index + 1;
          this.position.textContent = `${first}${last > first ? '–' + last : ''} / ${this.cards.length}`;
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.resize?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mue-before-after"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mue-image-comparison')){
  customElements.define('mue-image-comparison',class extends HTMLElement{
    connectedCallback(){
      if(this._controller)return;
      const input=this.querySelector('input[type="range"]');
      if(!input){
        if(!this._childrenObserver){
          this._childrenObserver=new MutationObserver(()=>this.connectedCallback());
          this._childrenObserver.observe(this,{childList:true,subtree:true});
        }
        return;
      }
      this._childrenObserver?.disconnect();
      this._childrenObserver=null;
      this._controller=new AbortController();
      const options={signal:this._controller.signal};
      const sync=()=>this.style.setProperty('--position',`${input.value}%`);
      input.addEventListener('input',sync,options);
      input.addEventListener('change',sync,options);
      sync();

      // Mobile/iOS: let the native range input manage the drag.
      // The previous custom pointer-capture implementation could jump or freeze
      // when the finger left the handle area.
      this.removeAttribute('data-mue-drag-ready');
      input.style.pointerEvents='auto';
      input.style.touchAction='pan-y';
      input.addEventListener('pointerdown',()=>this.classList.add('is-dragging'),options);
      input.addEventListener('pointerup',()=>this.classList.remove('is-dragging'),options);
      input.addEventListener('pointercancel',()=>this.classList.remove('is-dragging'),options);
      input.addEventListener('touchend',()=>this.classList.remove('is-dragging'),options);
    }
    disconnectedCallback(){
      this._controller?.abort();
      this._controller=null;
      this._childrenObserver?.disconnect();
      this._childrenObserver=null;
      this.removeAttribute('data-mue-drag-ready');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mue-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      document.querySelectorAll('.mue-hero__video:not([data-ready])').forEach(video => {
        video.dataset.ready = 'true';
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const connection = navigator.connection;
        if (motion.matches || connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
        let timer;
        let stopped = false;
        const fallback = () => {
          stopped = true;
          clearTimeout(timer);
          video.removeAttribute('data-playing');
          video.pause();
          video.removeAttribute('src');
          video.load();
        };
        video.addEventListener('playing', () => {
          if (stopped) return;
          clearTimeout(timer);
          video.setAttribute('data-playing', '');
        });
        video.addEventListener('waiting', () => {
          if (stopped) return;
          video.removeAttribute('data-playing');
          clearTimeout(timer);
          timer = setTimeout(fallback, 3500);
        });
        video.addEventListener('error', fallback, { once: true });
        motion.addEventListener('change', event => { if (event.matches) fallback(); });
        video.muted = true;
        video.src = window.matchMedia('(max-width: 749px)').matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        timer = setTimeout(fallback, 3500);
        video.play().catch(fallback);
      });
    };
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mue-lifestyle-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mue-lifestyle-carousel')) {
    customElements.define('mue-lifestyle-carousel', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const track = this.querySelector('.mue-lifestyle__track');
        const navigation = this.querySelector('.mue-lifestyle__navigation');
        const previous = navigation.querySelector('[data-direction="-1"]');
        const next = navigation.querySelector('[data-direction="1"]');
        const progress = this.querySelector('.mue-lifestyle__progress span');
        const update = () => {
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          const position = Math.max(0, Math.min(maximum, track.scrollLeft));
          navigation.hidden = maximum < 2;
          previous.disabled = position < 2;
          next.disabled = position >= maximum - 2;
          const fraction = Math.min(1, track.clientWidth / Math.max(1, track.scrollWidth));
          progress.style.width = `${fraction * 100}%`;
          progress.style.transform = `translateX(${maximum > 0 && fraction > 0 ? (position / maximum) * ((1 - fraction) / fraction) * 100 : 0}%)`;
        };
        const move = (direction) => {
          const cards = [...track.children];
          if (!cards.length) return;
          const edge = track.getBoundingClientRect().left;
          const starts = cards.map((card) => card.getBoundingClientRect().left - edge + track.scrollLeft);
          const current = starts.reduce((best, start, index) => Math.abs(start - track.scrollLeft) < Math.abs(starts[best] - track.scrollLeft) ? index : best, 0);
          const target = Math.max(0, Math.min(cards.length - 1, current + direction));
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          track.scrollTo({ left: Math.max(0, Math.min(maximum, starts[target])), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        navigation.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-direction]');
          if (button) move(Number(button.dataset.direction));
        }, options);
        track.addEventListener('keydown', (event) => {
          if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        track.addEventListener('scroll', update, { passive: true, signal: this.events.signal });
        this.addEventListener('click', (event) => {
          if (!event.target.closest('a[href="#mue-size-finder"]')) return;
          const select = document.querySelector('#mue-size-finder select');
          if (select) requestAnimationFrame(() => select.focus({ preventScroll: true }));
        }, options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() { this.events?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mue-model-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mue-model-guide')) {
  customElements.define('mue-model-guide', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.track = this.querySelector('.mue-model-guide__track');
      const options = { signal: this.events.signal };
      const buttons = Array.from(this.querySelectorAll('[data-family]'));
      const navigation = this.querySelector('.mue-model-guide__navigation');
      const previous = navigation.querySelector('[data-direction="-1"]');
      const next = navigation.querySelector('[data-direction="1"]');
      const updateNavigation = () => {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        navigation.hidden = maximum <= 2;
        previous.disabled = this.track.scrollLeft <= 2;
        next.disabled = this.track.scrollLeft >= maximum - 2;
      };
      const queueNavigation = () => {
        if (this.navigationFrame) return;
        this.navigationFrame = requestAnimationFrame(() => {
          this.navigationFrame = 0;
          updateNavigation();
        });
      };
      const applyFamily = family => {
        const active = buttons.find(button => button.dataset.family === family) || buttons[0];
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button === active)));
        this.querySelectorAll('[data-model-family]').forEach(card => {
          card.hidden = active.dataset.family !== 'all' && card.dataset.modelFamily !== active.dataset.family;
        });
        this.track.scrollTo({ left: 0, behavior: 'instant' });
        queueNavigation();
      };
      const readFamily = () => applyFamily(new URLSearchParams(window.location.search).get('gamme'));
      buttons.forEach(button => button.addEventListener('click', () => {
        applyFamily(button.dataset.family);
        const url = new URL(window.location.href);
        if (button.dataset.family === 'all') url.searchParams.delete('gamme');
        else url.searchParams.set('gamme', button.dataset.family);
        window.history.replaceState(window.history.state, '', url);
      }, options));
      this.track.addEventListener('scroll', queueNavigation, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(queueNavigation);
      this.resizeObserver.observe(this.track);
      readFamily();
      window.addEventListener('popstate', readFamily, options);
      navigation.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({
          left: this.track.clientWidth * .8 * Number(button.dataset.direction),
          behavior: reduced ? 'instant' : 'smooth'
        });
      }, options));
    }
    disconnectedCallback() {
      this.events?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.navigationFrame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mue-press"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
  const button=event.target.closest('.mue-press__pause');
  if(!button)return;
  const strip=button.closest('.mue-press');
  const paused=strip.dataset.paused!=='true';
  strip.dataset.paused=String(paused);
  button.setAttribute('aria-pressed',String(paused));
  button.textContent=paused?button.dataset.play:button.dataset.pause;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mue-product-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mue-product-proof')) {
    customElements.define('mue-product-proof', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        this.navigationObserver?.disconnect();
        this.events = new AbortController();
        this.boundVideos = new WeakSet();
        const options = { signal: this.events.signal };
        this.setupVideoNavigation();
        this.addEventListener('click', (event) => {
          const sizeLink = event.target.closest('[data-mue-video-size-link]');
          if (sizeLink && this.contains(sizeLink)) {
            const finder = document.querySelector('[data-mue-fit-widget]');
            if (finder) {
              event.preventDefault();
              this.querySelectorAll('video').forEach(video => video.pause());
              finder.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
              finder.querySelector('select:not([disabled]), input:not([disabled]), button')?.focus({ preventScroll: true });
            }
            return;
          }
          const control = event.target.closest('[data-video-start], [data-video-toggle]');
          if (!control || !this.contains(control)) return;
          const card = control.closest('[data-video-card]');
          const frame = card.querySelector('[data-video-frame]');
          const template = frame.querySelector('[data-video-template]');
          if (!template) return;
          const start = card.querySelector('[data-video-start]');
          const toggle = card.querySelector('[data-video-toggle]');
          const status = card.querySelector('[data-video-status]');
          let video = frame.querySelector('video:not(.mue-proof__video--mobile-native)');
          if (!video) {
            frame.append(template.content.cloneNode(true));
            video = frame.querySelector('video');
          }
          if (!video) return;
          video.muted = true;
          video.defaultMuted = true;
          video.controls = false;
          const reportError = (error) => {
            if (error?.name === 'AbortError') return;
            start.hidden = false;
            toggle.hidden = true;
            status.textContent = this.dataset.videoError;
            status.hidden = false;
            start.focus({ preventScroll: true });
          };
          const update = () => {
            const playing = !video.paused && !video.ended;
            toggle.dataset.playing = String(playing);
            toggle.setAttribute('aria-label', playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay);
          };
          if (!this.boundVideos.has(video)) {
            this.boundVideos.add(video);
            video.addEventListener('error', reportError, options);
            video.addEventListener('playing', () => { status.hidden = true; update(); }, options);
            video.addEventListener('pause', update, options);
            video.addEventListener('ended', update, options);
          }
          start.hidden = true;
          toggle.hidden = false;
          status.hidden = true;
          toggle.focus({ preventScroll: true });
          if (control === start || video.paused || video.ended) {
            if (video.ended) video.currentTime = 0;
            video.play().catch(reportError);
          } else video.pause();
          update();
        }, options);
        document.addEventListener('play', (event) => {
          if (!(event.target instanceof HTMLVideoElement) || !event.target.closest('mue-product-proof, mue-inline-video-rail, mue-detail-video')) return;
          document.querySelectorAll('mue-product-proof video, mue-inline-video-rail video, mue-detail-video video').forEach((video) => {
            if (video !== event.target) video.pause();
          });
        }, { capture: true, signal: this.events.signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.querySelectorAll('video').forEach((video) => video.pause());
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => { if (!entry.isIntersecting) entry.target.querySelectorAll('video').forEach(video => video.pause()); });
          }, { threshold: 0.05 });
          this.querySelectorAll('[data-video-frame]').forEach(frame => this.observer.observe(frame));
        }
      }
      setupVideoNavigation() {
        const navigation = this.querySelector('[data-video-navigation]');
        const track = this.querySelector('.mue-proof__grid--videos');
        if (!navigation || !track) return;
        const previous = navigation.querySelector('[data-video-direction="-1"]');
        const next = navigation.querySelector('[data-video-direction="1"]');
        const update = () => {
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          const position = Math.max(0, Math.min(maximum, track.scrollLeft));
          navigation.hidden = maximum < 2;
          previous.disabled = position < 2;
          next.disabled = position >= maximum - 2;
        };
        const move = (direction) => {
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          const position = Math.max(0, Math.min(maximum, track.scrollLeft));
          const edge = track.getBoundingClientRect().left;
          const starts = [...track.children].map(card => card.getBoundingClientRect().left - edge + track.scrollLeft);
          const target = direction > 0 ? starts.find(start => start > position + 2) ?? maximum : starts.filter(start => start < position - 2).at(-1) ?? 0;
          track.scrollTo({ left: Math.max(0, Math.min(maximum, target)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        navigation.addEventListener('click', (event) => {
          const button = event.target.closest('[data-video-direction]');
          if (button && !button.disabled) move(Number(button.dataset.videoDirection));
        }, { signal: this.events.signal });
        track.addEventListener('keydown', (event) => {
          if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal: this.events.signal });
        track.addEventListener('scroll', update, { passive: true, signal: this.events.signal });
        this.navigationObserver = new ResizeObserver(update);
        this.navigationObserver.observe(track);
        update();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        this.navigationObserver?.disconnect();
        this.querySelectorAll('video').forEach((video) => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mue-product-studio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mue-product-studio')) {
    customElements.define('mue-product-studio', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.stickyObserver?.disconnect();
        this.stickyStateObserver?.disconnect();
        this.modalObserver?.disconnect();
        this.events = new AbortController();
        this.desktop = matchMedia('(min-width: 900px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.setupSticky();
        this.track = this.querySelector('[data-gallery-track]');
        this.setupBundle();
        this.setupSizeFinder();
        if (!this.track) return;
        this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
        this.thumbnails = [...this.querySelectorAll('[data-gallery-thumbnail]')];
        this.thumbnailTrack = this.querySelector('[data-gallery-thumbnails]');
        this.previous = this.querySelector('[data-gallery-previous]');
        this.next = this.querySelector('[data-gallery-next]');
        this.counter = this.querySelector('[data-gallery-counter]');
        this.colours = [...this.querySelectorAll('[data-colour-slot]')];
        this.colourName = this.querySelector('[data-colour-selected-name]');
        this.dialog = this.querySelector('[data-zoom-dialog]');
        this.zoomImage = this.querySelector('[data-zoom-image]');
        this.active = 0;
        const options = { signal: this.events.signal };
        const variantImages = JSON.parse(this.dataset.variantImages || '[]');
        const syncBundlePhoto = (select) => {
          if (!select) return;
          const selected = select.options[select.selectedIndex]?.textContent.trim();
          const match = variantImages.find((variant) => variant.color === selected && variant.image);
          if (!match) return;
          const index = this.slides.findIndex((slide) => slide.dataset.imageId === match.image);
          if (index >= 0) this.goTo(index);
        };
        this.addEventListener('change', (event) => {
          const select = event.target;
          if (!(select instanceof HTMLSelectElement) || !select.matches('.mue-bundle-color-select')) return;
          syncBundlePhoto(select);
        }, options);
        this.bundlePhotoObserver?.disconnect();
        this.bundlePhotoObserver = new MutationObserver(() => {
          const select = this.querySelector('.moonbundle-option-active .mue-bundle-color-select');
          if (!select) return;
          syncBundlePhoto(select);
          this.bundlePhotoObserver.disconnect();
        });
        this.bundlePhotoObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        this.addEventListener('shopify:product:select', (event) => {
          if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;
          const selection = this.variantSelection = (this.variantSelection || 0) + 1;
          const signal = this.events.signal;
          event.promise.then(({ detail }) => {
            if (signal.aborted || !this.isConnected || selection !== this.variantSelection) return;
            if (detail?.productId && String(detail.productId) !== this.dataset.productId) return;
            const resource = detail?.resource;
            const imageId = resource?.featured_media?.id ?? resource?.featured_media?.preview_image?.id ?? resource?.featured_image?.id;
            if (imageId == null) return;
            const normalizedId = String(imageId).split('/').pop();
            const index = this.slides.findIndex((slide) => slide.dataset.imageId === normalizedId);
            if (index >= 0) this.goTo(index);
          }).catch(() => {});
        }, options);
        this.setAttribute('data-enhanced', '');
        this.querySelector('[data-gallery-controls]').hidden = false;
        this.querySelectorAll('[data-zoom-trigger], [data-gallery-thumbnail]').forEach((button) => { button.disabled = false; });
        this.colours.forEach((input) => { input.disabled = !this.slides.some((slide) => slide.dataset.imageSlot === input.dataset.colourSlot); });
        this.addEventListener('change', (event) => {
          const input = event.target;
          if (!(input instanceof HTMLInputElement) || !input.matches('[data-colour-slot]') || !input.checked) return;
          const index = this.slides.findIndex((slide) => slide.dataset.imageSlot === input.dataset.colourSlot);
          if (index >= 0) this.goTo(index, false);
        }, options);
        this.addEventListener('click', (event) => {
          const thumbnail = event.target.closest('[data-gallery-thumbnail]');
          if (thumbnail && this.contains(thumbnail)) this.goTo(Number(thumbnail.dataset.galleryThumbnail));
          if (event.target.closest('[data-gallery-previous]')) this.goTo(this.active - 1);
          if (event.target.closest('[data-gallery-next]')) this.goTo(this.active + 1);
          const zoom = event.target.closest('[data-zoom-trigger]');
          if (zoom && this.contains(zoom) && this.dialog && !this.dialog.open) {
            this.zoomImage.src = zoom.dataset.zoomSrc;
            this.zoomImage.alt = zoom.querySelector('img').alt;
            this.zoomImage.hidden = false;
            this.dialog.showModal();
          }
          if (event.target.closest('[data-zoom-close]')) this.dialog.close();
        }, options);
        this.track.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.goTo(0);
          else if (event.key === 'End') this.goTo(this.slides.length - 1);
          else this.goTo(this.active + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.track.addEventListener('scroll', () => {
          if (this.desktop.matches || this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            const trackLeft = this.track.getBoundingClientRect().left;
            let nearest = 0;
            let distance = Infinity;
            this.slides.forEach((slide, index) => {
              const delta = Math.abs(slide.getBoundingClientRect().left - trackLeft);
              if (delta < distance) { distance = delta; nearest = index; }
            });
            this.update(nearest);
          });
        }, { passive: true, signal: this.events.signal });
        this.desktop.addEventListener('change', () => this.goTo(this.active, false), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.zoomImage.hidden = true;
          this.zoomImage.removeAttribute('src');
        }, options);
        const explicitIndex = this.dataset.initialImageId ? this.slides.findIndex((slide) => slide.dataset.imageId === this.dataset.initialImageId) : -1;
        const defaultIndex = this.slides.findIndex((slide) => slide.dataset.imageSlot === this.dataset.initialImageSlot);
        this.goTo(explicitIndex >= 0 ? explicitIndex : defaultIndex >= 0 ? defaultIndex : 0, false);
      }
      setupBundle() {
        const bundle = this.querySelector('[data-bundle-preview]');
        if (!bundle) return;
        const formulas = [...bundle.querySelectorAll('[data-bundle-formula]')];
        const panels = [...bundle.querySelectorAll('[data-bundle-panel]')];
        const button = this.querySelector('[data-bundle-add]');
        const status = this.querySelector('[data-bundle-status]');
        const message = status?.querySelector('[data-bundle-message]');
        const checkCart = status?.querySelector('[data-bundle-check-cart]');
        let product;
        try { product = JSON.parse(bundle.querySelector('[data-bundle-product]')?.textContent || 'null'); } catch {}
        const validProduct = product && product.colorPosition > 0 && product.sizePosition > 0 && product.colorPosition !== product.sizePosition && Array.isArray(product.variants) && product.variants.length > 0 && product.variants.every((variant) => Array.isArray(variant.options) && variant.options.length === 2);
        const purchaseAllowed = Boolean(validProduct && product.canPurchase && product.unitPrice > 0 && product.variants.every((variant) => variant.price === product.unitPrice));
        let pending = false;
        let uncertain = false;
        let completed = false;
        const selectedPanel = () => {
          const selectedId = formulas.find((input) => input.checked)?.getAttribute('aria-controls');
          return panels.find((panel) => panel.id === selectedId);
        };
        const rowVariant = (row) => {
          if (!validProduct) return;
          const color = row.querySelector('[data-bundle-colour]')?.selectedOptions[0]?.dataset.productValue;
          const size = row.querySelector('[data-bundle-size]')?.value;
          if (!color || !size) return;
          return product.variants.find((variant) => variant.options[product.colorPosition - 1] === color && variant.options[product.sizePosition - 1] === size);
        };
        const syncAvailability = (row) => {
          if (!validProduct) return;
          const colors = row.querySelector('[data-bundle-colour]');
          const sizes = row.querySelector('[data-bundle-size]');
          const color = colors?.selectedOptions[0]?.dataset.productValue;
          if (!colors || !sizes) return;
          [...colors.options].forEach((option) => {
            option.disabled = !product.variants.some((variant) => variant.options[product.colorPosition - 1] === option.dataset.productValue && (!purchaseAllowed || variant.available));
          });
          [...sizes.options].forEach((option) => {
            if (!option.value) return;
            option.disabled = !product.variants.some((variant) => variant.options[product.colorPosition - 1] === color && variant.options[product.sizePosition - 1] === option.value && (!purchaseAllowed || variant.available));
          });
        };
        const showStatus = (text, reviewCart = false) => {
          if (!status || !message) return;
          message.textContent = text;
          status.hidden = !text;
          if (checkCart) checkCart.hidden = !reviewCart;
        };
        const refreshButton = () => {
          if (!button) return;
          button.disabled = !purchaseAllowed || pending || uncertain || completed;
          button.setAttribute('aria-busy', String(pending || completed));
          // Déclic : annoncer 2+1 OFFERT uniquement quand le pack de trois est sélectionné.
          const trioSelected = formulas.some((input) => input.checked && input.value === 'trio');
          const readyText = trioSelected && button.dataset.readyTrioLabel ? button.dataset.readyTrioLabel : button.dataset.readyLabel;
          button.textContent = pending || completed ? button.dataset.loadingLabel : uncertain ? button.dataset.errorLabel : purchaseAllowed ? readyText : button.dataset.previewLabel;
          formulas.forEach((input) => { input.disabled = pending || completed; });
          const active = selectedPanel();
          panels.forEach((panel) => { panel.disabled = panel !== active || pending || completed; });
        };
        const updateFormula = () => {
          const selectedId = formulas.find((input) => input.checked)?.getAttribute('aria-controls');
          let activePanel;
          panels.forEach((panel) => {
            const selected = panel.id === selectedId;
            panel.hidden = !selected;
            panel.disabled = !selected;
            if (selected) activePanel = panel;
          });
          if (activePanel) {
            ['title', 'price', 'compare', 'discount', 'average', 'quantity'].forEach((key) => {
              const element = bundle.querySelector(`[data-bundle-summary-${key}]`);
              if (!element) return;
              const value = activePanel.dataset[`summary${key.charAt(0).toUpperCase()}${key.slice(1)}`] || '';
              element.textContent = value;
              if (key === 'compare' || key === 'discount') element.hidden = !value;
            });
          }
          return activePanel;
        };
        const updatePieceThumbnail = (select) => {
          const image = select.closest('.mue-studio__bundle-piece')?.querySelector('[data-bundle-thumbnail]');
          const source = select.selectedOptions[0]?.dataset.thumbnailSrc;
          if (!image) return;
          image.hidden = !source;
          if (!source) return;
          image.removeAttribute('srcset');
          if (image.getAttribute('src') !== source) image.src = source;
        };
        const previewColour = (select) => {
          const slot = select?.selectedOptions[0]?.dataset.gallerySlot;
          const index = this.slides?.findIndex((slide) => slide.dataset.imageSlot === slot) ?? -1;
          if (index >= 0) this.goTo(index, false);
        };
        bundle.addEventListener('change', (event) => {
          if (!(event.target instanceof Element)) return;
          if (event.target.matches('[data-bundle-formula]')) {
            const panel = updateFormula();
            previewColour(panel?.querySelector('[data-bundle-colour]'));
          }
          if (event.target.matches('[data-bundle-colour]')) {
            updatePieceThumbnail(event.target);
            previewColour(event.target);
            syncAvailability(event.target.closest('.mue-studio__bundle-piece'));
          }
          if (!uncertain) showStatus('');
          refreshButton();
        }, { signal: this.events.signal });
        bundle.querySelectorAll('[data-bundle-colour]').forEach(updatePieceThumbnail);
        bundle.querySelectorAll('.mue-studio__bundle-piece').forEach(syncAvailability);
        updateFormula();
        refreshButton();
        button?.addEventListener('click', async () => {
          if (!purchaseAllowed || pending || uncertain || completed) return;
          const panel = selectedPanel();
          if (!panel) return;
          const rows = [...panel.querySelectorAll('.mue-studio__bundle-piece')];
          const missing = rows.find((row) => !row.querySelector('[data-bundle-size]')?.value);
          if (missing) {
            showStatus(button.dataset.selectLabel);
            missing.querySelector('[data-bundle-size]')?.focus();
            return;
          }
          const unavailable = rows.find((row) => {
            const variant = rowVariant(row);
            return !variant?.available || variant.price !== product.unitPrice;
          });
          if (unavailable) {
            showStatus(button.dataset.unavailableLabel);
            unavailable.querySelector('[data-bundle-size]')?.focus();
            return;
          }
          const quantities = new Map();
          rows.forEach((row) => {
            const variant = rowVariant(row);
            quantities.set(variant.id, (quantities.get(variant.id) || 0) + 1);
          });
          if (!quantities.size) return;
          pending = true;
          showStatus('');
          refreshButton();
          try {
            const response = await fetch(product.addUrl, {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [...quantities].map(([id, quantity]) => ({ id, quantity })) })
            });
            const result = await response.json();
            if (!response.ok || result.status || !Array.isArray(result.items) || !result.items.length) throw new Error(button.dataset.errorLabel);
            completed = true;
            window.location.assign(product.cartUrl);
          } catch {
            uncertain = true;
            showStatus(button.dataset.checkLabel, true);
            status?.focus();
          } finally {
            pending = false;
            refreshButton();
          }
        }, { signal: this.events.signal });
        window.addEventListener('pageshow', (event) => {
          if (!event.persisted || !completed) return;
          completed = false;
          pending = false;
          refreshButton();
        }, { signal: this.events.signal });
      }
      focusPurchaseOptions() {
        const finder = this.querySelector('#mue-size-finder');
        const nativeOptions = this.querySelector('variant-picker, variant-picker-component, [data-variant-picker]');
        const options = finder || this.querySelector('[data-bundle-preview]') || nativeOptions || this.nativeDetails || this.querySelector('.mue-studio__details');
        if (!options) return;
        options.scrollIntoView({ block: 'start', behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
        const control = options.querySelector('select:not([disabled]), input:not([disabled]):not([type="hidden"]), button:not([disabled])');
        control?.focus({ preventScroll: true });
      }
      setupSizeFinder() {
        if (!this.querySelector('#mue-size-finder')) return;
        document.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const link = event.target.closest('a[href]');
          if (!link) return;
          const url = new URL(link.href, location.href);
          if (url.origin !== location.origin || url.pathname !== location.pathname || url.hash !== '#mue-size-finder') return;
          event.preventDefault();
          if (location.hash !== url.hash) history.replaceState(history.state, '', url.hash);
          this.focusPurchaseOptions();
        }, { signal: this.events.signal });
        window.addEventListener('hashchange', () => {
          if (location.hash === '#mue-size-finder') this.focusPurchaseOptions();
        }, { signal: this.events.signal });
        if (location.hash === '#mue-size-finder') this.focusPurchaseOptions();
      }
      setupSticky() {
        this.sticky = this.querySelector('[data-sticky-bar]');
        if (!this.sticky) return;
        this.nativeDetails = this.querySelector('[data-testid="product-information-details"]');
        const target = this.querySelector('[data-bundle-add]') || this.nativeDetails?.querySelector('product-form-component button[type="submit"]');
        const stickyButton = this.sticky.querySelector('[data-sticky-options]');
        if (!target || !stickyButton) return;
        const visibilityTarget = target.hidden ? this.querySelector('[data-bundle-preview]') || target : target;
        this.stickyTarget = target;
        const isPending = () => target.disabled && (target.getAttribute('aria-busy') === 'true' || (target.dataset.loadingLabel && target.textContent.trim() === target.dataset.loadingLabel.trim()));
        const syncButton = () => {
          const pending = isPending();
          const label = !target.disabled || pending ? target.textContent.trim() : stickyButton.dataset.optionsLabel;
          if (label && stickyButton.textContent !== label) stickyButton.textContent = label;
          stickyButton.disabled = Boolean(pending);
          stickyButton.setAttribute('aria-busy', String(Boolean(pending)));
          stickyButton.dataset.stickyAction = target.disabled ? 'options' : 'submit';
        };
        const updateVisibility = () => {
          const modalOpen = [...document.querySelectorAll('dialog[open], [aria-modal="true"]:not([aria-hidden="true"]), [data-drawer-open="true"], header-drawer details.menu-drawer-container[open]')].some((element) => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
          const pastPurchaseButton = visibilityTarget.getClientRects().length > 0 && visibilityTarget.getBoundingClientRect().bottom < 0;
          this.sticky.hidden = this.desktop.matches || !pastPurchaseButton || modalOpen;
        };
        if ('IntersectionObserver' in window) {
          this.stickyObserver = new IntersectionObserver(updateVisibility, { threshold: 0 });
          this.stickyObserver.observe(visibilityTarget);
        }
        this.stickyStateObserver = new MutationObserver(syncButton);
        this.stickyStateObserver.observe(target, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
        this.modalObserver = new MutationObserver(updateVisibility);
        this.modalObserver.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'aria-hidden', 'aria-modal', 'data-drawer-open'] });
        document.addEventListener('toggle', updateVisibility, { capture: true, signal: this.events.signal });
        window.addEventListener('scroll', updateVisibility, { passive: true, signal: this.events.signal });
        this.desktop.addEventListener('change', updateVisibility, { signal: this.events.signal });
        stickyButton.addEventListener('click', () => {
          if (isPending()) return;
          if (!target.disabled) target.click();
          else this.focusPurchaseOptions();
        }, { signal: this.events.signal });
        syncButton();
        updateVisibility();
      }
      update(index) {
        this.active = Math.max(0, Math.min(index, this.slides.length - 1));
        this.slides.forEach((slide, position) => slide.classList.toggle('is-active', position === this.active));
        this.thumbnails.forEach((thumbnail, position) => thumbnail.setAttribute('aria-current', String(position === this.active)));
        const thumbnail = this.thumbnails[this.active];
        if (!this.desktop.matches && thumbnail && this.thumbnailTrack) {
          const bounds = thumbnail.getBoundingClientRect();
          const rail = this.thumbnailTrack.getBoundingClientRect();
          const offset = bounds.left < rail.left ? bounds.left - rail.left - 4 : bounds.right > rail.right ? bounds.right - rail.right + 4 : 0;
          if (offset) this.thumbnailTrack.scrollBy({ left: offset, behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
        }
        this.previous.disabled = this.active === 0;
        this.next.disabled = this.active === this.slides.length - 1;
        this.counter.textContent = this.dataset.counterTemplate.replace('[current]', String(this.active + 1)).replace('[total]', String(this.slides.length));
        const activeSlot = this.slides[this.active].dataset.imageSlot;
        const colour = this.colours.find((input) => input.dataset.colourSlot === activeSlot || input.dataset.colourSecondarySlot === activeSlot);
        if (colour) {
          colour.checked = true;
          if (this.colourName) this.colourName.textContent = colour.dataset.colourName;
        }
      }
      goTo(index, animate = true) {
        const focusInSlide = this.slides.some((slide) => slide.contains(document.activeElement));
        this.update(index);
        if (!this.desktop.matches) {
          this.track.scrollTo({ left: this.slides[this.active].offsetLeft - this.slides[0].offsetLeft, behavior: animate && !this.reducedMotion.matches ? 'smooth' : 'instant' });
        }
        if (focusInSlide) this.slides[this.active].querySelector('[data-zoom-trigger]')?.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.bundlePhotoObserver?.disconnect();
        this.events?.abort();
        this.stickyObserver?.disconnect();
        this.stickyStateObserver?.disconnect();
        this.modalObserver?.disconnect();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = null;
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mue-reassurance"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.mue-reassurance--editorial a[href="#mue-product-exchanges"]');
    if (!link) return;
    const details = document.getElementById('mue-product-exchanges');
    if (details?.tagName === 'DETAILS') details.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mue-reglage-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mue-detail-video')) {
    customElements.define('mue-detail-video', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const video = this.querySelector('video');
        const button = this.querySelector('[data-detail-video-toggle]');
        const status = this.querySelector('[role="status"]');
        if (!video || !button || !status) return;
        video.muted = true;
        video.defaultMuted = true;
        video.controls = false;
        button.hidden = false;
        const update = () => {
          const playing = !video.paused && !video.ended;
          button.dataset.playing = String(playing);
          button.setAttribute('aria-label', playing ? button.dataset.labelPause : button.dataset.labelPlay);
        };
        const error = (failure) => {
          if (failure?.name === 'AbortError') return;
          status.textContent = this.dataset.error;
          status.hidden = false;
          update();
        };
        button.addEventListener('click', () => {
          status.hidden = true;
          button.dataset.started = 'true';
          if (video.paused || video.ended) {
            video.muted = true;
            if (video.ended) video.currentTime = 0;
            video.play().catch(error);
          } else video.pause();
          update();
        }, options);
        video.addEventListener('playing', () => { status.hidden = true; update(); }, options);
        video.addEventListener('pause', update, options);
        video.addEventListener('ended', update, options);
        video.addEventListener('error', error, options);
        document.addEventListener('play', (event) => {
          const scopes = 'mue-detail-video, mue-inline-video-rail, mue-product-proof';
          if (!(event.target instanceof HTMLVideoElement) || !event.target.closest(scopes)) return;
          document.querySelectorAll('mue-detail-video video, mue-inline-video-rail video, mue-product-proof video').forEach((other) => {
            if (other !== event.target) other.pause();
          });
        }, { capture: true, signal: this.events.signal });
        document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) video.pause(); }, { threshold: 0.05 });
          this.observer.observe(this);
        }
        update();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        this.querySelector('video')?.pause();
      }
    });
  }
  document.addEventListener('click', (event) => {
    const sizeLink = event.target.closest('.mue-reglage-details [data-mue-video-size-link]');
    if (sizeLink) {
      const finder = document.querySelector('[data-mue-fit-widget]');
      if (finder) {
        event.preventDefault();
        document.querySelectorAll('mue-detail-video video, mue-inline-video-rail video, mue-product-proof video').forEach(video => video.pause());
        finder.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        finder.querySelector('select:not([disabled]), input:not([disabled]), button')?.focus({ preventScroll: true });
      }
      return;
    }
    const link = event.target.closest('.mue-reglage-exchanges a[href="#mue-product-exchanges"], .mue-studio a[href="#mue-product-exchanges"]');
    if (!link) return;
    const target = document.getElementById('mue-product-exchanges');
    if (target) target.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mue-size-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mue-size-gallery')) {
    customElements.define('mue-size-gallery', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.track = this.querySelector('[data-size-gallery-track]');
        this.navigation = this.querySelector('[data-size-gallery-navigation]');
        if (!this.track || !this.navigation) return;
        this.previous = this.querySelector('[data-size-gallery-previous]');
        this.next = this.querySelector('[data-size-gallery-next]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }
      move(direction) {
        const card = this.track.querySelector('.mue-size-gallery__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        const limit = this.track.scrollWidth - this.track.clientWidth;
        this.navigation.hidden = limit < 3;
        this.previous.disabled = this.track.scrollLeft < 3;
        this.next.disabled = this.track.scrollLeft >= limit - 3;
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.resize?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
